var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guidemark-Admin-Desktop-Worklog-details-add-work-(line)",
    transform: "translate(-912.000000, -537.000000)",
    fill: "#a4a5b3",
    stroke: "#a4a5b3",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-/-Work-log-details-/-Scrolled",
    transform: "translate(590.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(322.000000, 484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Close-/-Red",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5625,0.4375 C13.8041246,0.679124578 13.8041246,1.07087542 13.5625,1.3125 L7.875,7 L13.5625,12.6875 C13.8041246,12.9291246 13.8041246,13.3208754 13.5625,13.5625 C13.3208754,13.8041246 12.9291246,13.8041246 12.6875,13.5625 L7,7.875 L1.3125,13.5625 C1.07087542,13.8041246 0.679124578,13.8041246 0.4375,13.5625 C0.195875422,13.3208754 0.195875422,12.9291246 0.4375,12.6875 L6.125,7 L0.4375,1.3125 C0.195875422,1.07087542 0.195875422,0.679124578 0.4375,0.4375 C0.679124578,0.195875422 1.07087542,0.195875422 1.3125,0.4375 L7,6.125 L12.6875,0.4375 C12.9291246,0.195875422 13.3208754,0.195875422 13.5625,0.4375 Z",
    id: "ion-ios-close-empty---Ionicons"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGrey);
export default __webpack_public_path__ + "static/media/close-icon-grey.2d5a06365cf10dba20935a82c4352616.svg";
export { ForwardRef as ReactComponent };